import { readThreadItemDetails } from '@/experiences/sales-portal/domain/superintelligence/blocs/utils/thread-item-details';
import { useAuiState } from '@assistant-ui/store';

export const useOpenThread = () => {
  const threadId = useAuiState((s) => s.threads.mainThreadId);
  const status = useAuiState(
    (s) =>
      s.threads.threadItems.find(
        (thread) => thread.id === s.threads.mainThreadId,
      )?.status,
  );
  const title = useAuiState(
    (s) =>
      s.threads.threadItems.find(
        (thread) => thread.id === s.threads.mainThreadId,
      )?.title,
  );
  const persisted = useAuiState(
    (s) =>
      readThreadItemDetails(
        s.threads.threadItems.find(
          (thread) => thread.id === s.threads.mainThreadId,
        )?.custom,
      ).persisted,
  );

  return { archived: status === 'archived', persisted, threadId, title };
};
